import React from "react";
import { t } from "ttag";

import styles from "./BlankMattressHeader.module.scss";

interface IBlankMattressHeaderProps {
    className?: string;
}

export const BlankMattressHeader = ({
    className,
}: IBlankMattressHeaderProps): React.JSX.Element => {
    return (
        <div className={`${styles.compareCard} ${className || ""}`}>
            <div className={styles.content}>
                <p className={styles.text}>
                    {t`Add an additional mattress`}
                    <br />
                    {t`to compare`}
                </p>
            </div>

            <div className={styles.cornerTopLeft}></div>
            <div className={styles.cornerTopRight}></div>
            <div className={styles.cornerBottomLeft}></div>
            <div className={styles.cornerBottomRight}></div>
        </div>
    );
};
